import React from "react";

export class SidebarErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="bg-white rounded-xl flex flex-col overflow-hidden border border-surface-border shadow-sm min-h-[300px]">
          <div className="flex items-center gap-4 py-3 px-5 border-b border-surface-border bg-white">
            <h3 className="text-sm font-semibold text-grey">
              {this.props.title || "Error"}
            </h3>
          </div>
          <div className="flex flex-col items-center justify-center flex-1 px-6 text-center">
            <p className="text-sm text-mediumgrey">
              Something went wrong loading this section.
            </p>
            <button
              onClick={() => this.setState({ hasError: false })}
              className="mt-3 px-4 py-2 text-sm font-medium text-primary border border-primary/30 rounded-lg hover:bg-primary/5 transition-colors cursor-pointer"
            >
              Try again
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
